<template>
     <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid class="container-transactions-volume">
                <v-layout row wrap align-center>
                    <v-flex xs2 class="mr-3">
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="dates.fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="dates.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="dates.fromDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="dates.toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="dates.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="dates.toDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2 text-xs-right>
                        <v-btn class="downloadBtn" v-if="!download" color="primary" fab small dark @click="downloadReport(); download = true;">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                        <v-progress-circular v-else class="downloadProgress" indeterminate color="primary"></v-progress-circular>
                    </v-flex>
                </v-layout>

                <v-layout row wrap align-center>
                    <v-flex xs12>
                        <v-card>
                            <v-data-table id="totalTransactionsTbl" :headers="tableTotalsHeaders" :items="totalsArr" hide-actions>
                                <template v-slot:items="props">
                                    <td class="text-xs-left">{{ props.item.total }}</td>
                                    <td class="text-xs-left">{{ props.item.threeD }}</td>
                                    <td class="text-xs-left">{{ props.item.cp }}</td>
                                    <td class="text-xs-left">{{ props.item.db }}</td>
                                    <td class="text-xs-left">{{ props.item.dr }}</td>
                                    <td class="text-xs-left">{{ props.item.ds }}</td>
                                    <td class="text-xs-left">{{ props.item.pa }}</td>
                                    <td class="text-xs-left">{{ props.item.rb }}</td>
                                    <td class="text-xs-left">{{ props.item.rf }}</td>
                                    <td class="text-xs-left">{{ props.item.rg }}</td>
                                    <td class="text-xs-left">{{ props.item.rr }}</td>
                                    <td class="text-xs-left">{{ props.item.rs }}</td>
                                    <td class="text-xs-left">{{ props.item.rv }}</td>
                                    <td class="text-xs-left">{{ props.item.sd }}</td>
                                </template>
                            </v-data-table>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn color="primary" @click="selected = []; totalsArr = [];">Clear</v-btn>
                            </v-card-actions>
                            </v-card>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                      
                        <v-flex xs3 offset-xs9 class="mb-4">
                            <v-text-field v-model="searchTable" append-icon="search" label="Search" single-line hide-details></v-text-field>
                        </v-flex>
                       
                        <v-data-table v-model="selected" :headers="tableHeaders" :items="transactions" :search="searchTable" item-key="merchantName" :loading="loading" hide-actions class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <td><v-checkbox v-model="props.selected" @change="onCheckboxChange(props.item)" primary hide-details></v-checkbox></td>
                                <td class="text-xs-left">{{ props.item.divisionName }}</td>
                                <td class="text-xs-left">{{ props.item.merchantName }}</td>
                                <td class="text-xs-left">{{ props.item.total_transactions }}</td>
                                <td class="text-xs-left">{{ props.item.ThreeD }}</td>
                                <td class="text-xs-left">{{ props.item.CP }}</td>
                                <td class="text-xs-left">{{ props.item.DB }}</td>
                                <td class="text-xs-left">{{ props.item.DR }}</td>
                                <td class="text-xs-left">{{ props.item.DS }}</td>
                                <td class="text-xs-left">{{ props.item.PA }}</td>
                                <td class="text-xs-left">{{ props.item.RB }}</td>
                                <td class="text-xs-left">{{ props.item.RF }}</td>
                                <td class="text-xs-left">{{ props.item.RG }}</td>
                                <td class="text-xs-left">{{ props.item.RR }}</td>
                                <td class="text-xs-left">{{ props.item.RS }}</td>
                                <td class="text-xs-left">{{ props.item.RV }}</td>
                                <td class="text-xs-left">{{ props.item.SD }}</td>
                            </template> 
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
     </v-content>
</template>

<script>
import axios from 'axios';

export default {
        data() {
            return {
                dates: {
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10)
                },
                fromDateModal: false,
                toDateModal: false,
                loading: true,
                transactions: [],
                searchTable: '',
                tableHeaders: [{ text: 'Select', sortable: false },
                               { text: 'Division', value: 'divisionName', sortable: false },
                               { text: 'Merchant', value: 'merchantName', sortable: false },
                               { text: 'Total', value: 'total_transactions', sortable: false },
                               { text: '3D', value: 'ThreeD', sortable: false },
                               { text: 'CP', value: 'CP', sortable: false },
                               { text: 'DB', value: 'DB', sortable: false },
                               { text: 'DR', value: 'DR', sortable: false },
                               { text: 'DS', value: 'DS', sortable: false },
                               { text: 'PA', value: 'PA', sortable: false },
                               { text: 'RB', value: 'RB', sortable: false },
                               { text: 'RF', value: 'RF', sortable: false },
                               { text: 'RG', value: 'RG', sortable: false },
                               { text: 'RR', value: 'RR', sortable: false },
                               { text: 'RS', value: 'RS', sortable: false },
                               { text: 'RV', value: 'RV', sortable: false },
                               { text: 'SD', value: 'SD', sortable: false }],
                tableTotalsHeaders: [{ text: 'Total', value: 'total_transactions', sortable: false },
                                    { text: '3D', value: 'ThreeD', sortable: false },
                                    { text: 'CP', value: 'CP', sortable: false },
                                    { text: 'DB', value: 'DB', sortable: false },
                                    { text: 'DR', value: 'DR', sortable: false },
                                    { text: 'DS', value: 'DS', sortable: false },
                                    { text: 'PA', value: 'PA', sortable: false },
                                    { text: 'RB', value: 'RB', sortable: false },
                                    { text: 'RF', value: 'RF', sortable: false },
                                    { text: 'RG', value: 'RG', sortable: false },
                                    { text: 'RR', value: 'RR', sortable: false },
                                    { text: 'RS', value: 'RS', sortable: false },
                                    { text: 'RV', value: 'RV', sortable: false },
                                    { text: 'SD', value: 'SD', sortable: false }],
                download: false,
                selected: [],
                totalsArr: [],
                totals: {
                    total: 0,
                    threeD: 0,
                    cp: 0,
                    db: 0,
                    dr: 0,
                    ds: 0,
                    pa: 0,
                    rf: 0,
                    rb: 0,
                    rg: 0,
                    rr: 0,
                    rs: 0,
                    rv: 0,
                    sd: 0,
                }
            }
        },
        beforeMount() {
           this.getTransactionsVolume();
        },
        methods: {
            handleDateChange() {
                if(this.dates.toDate < this.dates.fromDate) {
                    this.dates.fromDate = this.dates.toDate;
                }
                this.$refs.fromDateDialog.save(this.dates.fromDate);
                this.$refs.toDateDialog.save(this.dates.toDate);
                this.loading = true;
                this.getTransactionsVolume();
            },
            getTransactionsVolume() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-volume',
                data: { fromDate: this.dates.fromDate, toDate: this.dates.toDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.transactions = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            downloadReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-volume-pdf',
                data: { fromDate: this.dates.fromDate, toDate: this.dates.toDate },
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'transactions-volume-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.download = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            onCheckboxChange(e) {

                this.totalsArr = [];
                this.totals.total = this.selected.reduce((acc, obj) => acc + parseInt(obj.total_transactions), 0);
                this.totals.threeD = this.selected.reduce((acc, obj) => acc + parseInt(obj.ThreeD), 0);
                this.totals.cp = this.selected.reduce((acc, obj) => acc + parseInt(obj.CP), 0);
                this.totals.db = this.selected.reduce((acc, obj) => acc + parseInt(obj.DB), 0);
                this.totals.dr = this.selected.reduce((acc, obj) => acc + parseInt(obj.DR), 0);
                this.totals.ds = this.selected.reduce((acc, obj) => acc + parseInt(obj.DS), 0);
                this.totals.pa = this.selected.reduce((acc, obj) => acc + parseInt(obj.PA), 0);
                this.totals.rb = this.selected.reduce((acc, obj) => acc + parseInt(obj.RB), 0);
                this.totals.rf = this.selected.reduce((acc, obj) => acc + parseInt(obj.RF), 0);
                this.totals.rg = this.selected.reduce((acc, obj) => acc + parseInt(obj.RG), 0);
                this.totals.rr = this.selected.reduce((acc, obj) => acc + parseInt(obj.RR), 0);
                this.totals.rv = this.selected.reduce((acc, obj) => acc + parseInt(obj.RV), 0);
                this.totals.rs = this.selected.reduce((acc, obj) => acc + parseInt(obj.RS), 0);
                this.totals.sd = this.selected.reduce((acc, obj) => acc + parseInt(obj.SD), 0);
                this.totalsArr.push(this.totals);
            }
        }
}
</script>

<style>
.container-transactions-volume .dialog-btn-container {
    margin-top: 1px;
}

.downloadBtn, .downloadProgress {
    width: 36px !important;
    height: 36px !important;
    margin: 13px 0px 0px 0px !important;
}

#totalTransactionsTbl tbody tr {
    border-bottom: 1px solid rgba(0,0,0,.12);
}
</style>
